import React, { useEffect } from 'react';
import { toast } from 'react-toastify';

const ToastHandler = () => {
  useEffect(() => {
    const handleToast = (event) => {
      const { message, type } = event.detail;
      
      switch (type) {
        case 'success':
          toast.success(message);
          break;
        case 'error':
          toast.error(message);
          break;
        default:
          toast.info(message);
      }
    };

    window.addEventListener('show-toast', handleToast);
    return () => window.removeEventListener('show-toast', handleToast);
  }, []);

  return null;
};

export default ToastHandler;